import { ConsentOverlay, handleEmbed } from '@3pc/consent-overlay';
import { MapOSM } from '../map/map-osm';
import { lang } from '../../../shared/js/globals/language';

const initConsentOverlays = () => {
  const overlays = document.querySelectorAll('[data-consent-type]');
  const overlayInstances = [];
  const maps = [];

  overlays.length &&
    overlays.forEach(overlay => {
      const container = overlay;
      const overlayInstance = new ConsentOverlay({
        container,
        nameSpace: 'vdk',
        onActivation: (
          container = this.container,
          consentType,
          consentSubtype
        ) => {
          if (consentType === 'youtube') {
            handleEmbed(container, true);
          }
          if (consentType === 'iframe') {
            handleEmbed(container, true);
          }
          if (consentType === 'podigee' || consentType === 'tiktok') {
            const content = container.querySelector(
              '.consent-overlay__content'
            );

            overlayInstance.resetContent =
              overlayInstance.resetContent || content.innerHTML;

            if (overlayInstance.activeContent) {
              content.replaceWith(overlayInstance.activeContent);
              return;
            }

            if (!overlayInstance.activeContent) {
              const config = {
                attributes: true,
                childList: true,
                subtree: true,
              };
              const callback = () => {
                overlayInstance.activeContent = content.cloneNode(true);
              };
              overlayInstance.observer = new MutationObserver(callback);
              overlayInstance.observer.observe(content, config);

              handleEmbed(container, true);

              return;
            }
          }
          if (consentType === 'osm') {
            const map = container.querySelector('.map');
            if (map) {
              const mapInstance = new MapOSM({
                container: map,
                mapFitBounds: true,
              });

              mapInstance.init();
              maps.push(mapInstance);
            }
          }
          if (consentType === 'videoplayer') {
            // init videoplayer
          }

          // Focus opt-in
          if (container.contains(document.activeElement)) {
            const content = container.querySelector(
              '.consent-overlay__content'
            );
            content.setAttribute('tabindex', -1);
            content.focus();
          }
        },
        onDeactivation: (container, consentType, consentSubtype) => {
          if (consentType === 'youtube') {
            handleEmbed(container, false);
          }
          if (consentType === 'iframe') {
            handleEmbed(container, false);
          }
          if (consentType === 'podigee' || consentType === 'tiktok') {
            overlayInstance.observer.disconnect();
            // delete window.podigeePodcastPlayers;
            container.querySelector('.consent-overlay__content').innerHTML =
              overlayInstance.resetContent;
            //     .replace(
            //       'podigee-podcast-player.js',
            //       `podigee-podcast-player.js?${Date.now()}`
            //     )
            //     .replace(
            //       '?context=external',
            //       `?${Date.now()}&context=external`
            //     );
          }
          if (consentType === 'osm') {
            maps.forEach(map => {
              map.destroy();
            });
            maps.length = 0;
          }

          // Focus container
          container.setAttribute('tabindex', -1);
          container.focus();
        },
      });

      overlayInstance.init();
      overlayInstances.push(overlayInstance);
    });

  return overlayInstances;
};

export { initConsentOverlays };

// TODO: add id

const labels = {
  de: {
    deactivate: 'Youtube-Inhalte deaktivieren',
    loadAlways: 'Inhalte immer laden',
    loadOnce: 'Inhalt einmal laden',
    status: 'Stand',
    titleFallback: 'Youtube-Video',
    video: 'Video',
    youtubeOverlayDescription:
      'Auf Basis Ihrer Cookie-Einstellungen haben wir die Verbindung zu YouTube blockiert. Diese Inhalte können Sie über die Cookie-Einstellungen oder über die unterstehenden Buttons aktivieren.',
  },
  en: {
    deactivate: 'Disable all YouTube content',
    loadAlways: 'Always load content',
    loadOnce: 'Load content once',
    status: 'Status',
    titleFallback: 'Youtube video',
    video: 'Video',
    youtubeOverlayDescription:
      'Based on your cookie settings, we have blocked the connection to YouTube. You can activate this content via the cookie settings or using the buttons below.',
  },
};

export const templateConsentOverlayVideo = (video, title) => {
  if (!video && !video.externalSource) return '';

  return `
<div class="consent-overlay consent-overlay--timeline" role="region" aria-labelledby="[unique Inhaltselement-ID]" data-consent-type="${
    video.externalSource.provider
  }">
    <div class="consent-overlay__opt-in">
      <div class="consent-overlay__decoration">
        <span class="consent-overlay__icon icon icon--privacy">
          <svg class="icon__svg" role="img" aria-hidden="true">
            <use href="#icon-privacy"></use>
          </svg>
        </span>
      </div>
      <div class="consent-overlay__description">
        <span id="[unique Inhaltselement-ID]" class="consent-overlay__heading">${
          title ? `${labels[lang].video}: ${title}` : labels[lang].titleFallback
        }</span>
        <p>${labels[lang].youtubeOverlayDescription}</p>
        <div class="consent-overlay__buttons">
          <button class="consent-overlay__button" data-accept="once">${
            labels[lang].loadOnce
          }</button>
          <button class="consent-overlay__button" data-accept="always">${
            labels[lang].loadAlways
          }</button>
        </div>
      </div>
    </div>
    <div class="consent-overlay__content">
      <figure class="player player--video player--consent-overlay" aria-labelledby="[unique Inhaltselement-ID]">
    <span id="[unique Inhaltselement-ID]" class="sr-only">Video-Player ${
      title || labels[lang].titleFallback
    }</span>
    <div class="player__player">
        <iframe class="player__iframe" data-src="${
          video.externalSource.embedUrl
        }" title="${title}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen="allowfullscreen"></iframe>
    </div>
    ${
      video.externalSource.statusDate
        ? `
      <figcaption class="player__caption">${labels[lang].status}:
        <time datetime="${video.externalSource.statusDateTime}">${video.externalSource.statusDate}</time>
      </figcaption>
    `
        : ''
    }
  </figure>
    </div>
    <div class="consent-overlay__opt-out">
      <button class="consent-overlay__button" data-revoke="">${
        labels[lang].deactivate
      }</button>
    </div>
  </div>
  `;
};
